import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import useFetch from "../hooks/useFetch";
import { useFooterReveal } from "../hooks/useFooterReveal";
import Footer from "../components/Footer";
import ModalForm from "../components/ModalForm";
import "../css/legal.css";

export default function Legal() {
  const [modalShow, setModalShow] = useState(false);
  // Тот же логотип, что в шапке главной (contact.Logo из Strapi).
  const contactsFetch = useFetch(`${window.$host}/api/contact?populate=*`);
  const logo =
    contactsFetch.data && contactsFetch.data.data && contactsFetch.data.data.Logo;
  const freezeRef = useFooterReveal();

  // Глобальный body { overflow: hidden } нужен свайперу на главной.
  // На /legal включаем обычный скролл и возвращаем как было при уходе.
  useEffect(() => {
    // При переходе по SPA-ссылке позиция скролла не сбрасывается — открываем
    // страницу с начала (иначе попадаешь в футер, откуда был клик).
    window.scrollTo(0, 0);
    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="legal">
      <Helmet>
        <title>Сведения о компании и продуктах — its9it</title>
        <meta
          name="description"
          content="Сведения о компании и продуктах, раскрываемые в соответствии с приказом Минцифры России от 02.06.2025 № 511"
        />
      </Helmet>

      <div className="legal-freeze" ref={freezeRef}>
      <header className="legal-header">
        <div className="container legal-header__inner">
          <Link to="/" className="legal-logo" aria-label="На главную">
            {logo ? (
              <img
                src={window.$host + logo.url}
                alt={logo.alternativeText || "its9it"}
              />
            ) : (
              "its9it"
            )}
          </Link>
          <button className="dark-arrow" onClick={() => setModalShow(true)}>
            <span className="dark-arrow__text">Запустить продукт</span>
            <span className="dark-arrow__arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="12"
                viewBox="0 0 17 12"
                fill="none"
              >
                <circle cx="4" cy="6" r="1" transform="rotate(90 4 6)" fill="white" />
                <circle cx="1" cy="6" r="1" transform="rotate(90 1 6)" fill="white" />
                <circle cx="7" cy="6" r="1" transform="rotate(90 7 6)" fill="white" />
                <circle cx="10" cy="6" r="1" transform="rotate(90 10 6)" fill="white" />
                <circle cx="13" cy="6" r="1" transform="rotate(90 13 6)" fill="white" />
                <circle cx="16" cy="6" r="1" transform="rotate(90 16 6)" fill="white" />
                <circle cx="13" cy="9" r="1" transform="rotate(90 13 9)" fill="white" />
                <circle cx="13" cy="3" r="1" transform="rotate(90 13 3)" fill="white" />
                <circle cx="10" cy="0.5" r="0.5" transform="rotate(90 10 0.5)" fill="white" />
                <circle cx="10" cy="11.5" r="0.5" transform="rotate(90 10 11.5)" fill="white" />
              </svg>
            </span>
          </button>
        </div>
      </header>

      <main className="legal-main">
        <div className="container">
          <Link to="/" className="legal-back">
            ← Вернуться на главную
          </Link>
          <h1 className="title-3 legal-title">Сведения о компании и продуктах</h1>
          <p className="text-20 text-gray legal-subtitle">
            Информация раскрывается в соответствии с требованиями приказа
            Минцифры России от 02.06.2025 № 511.
          </p>

          <div className="legal-content">
            <div className="legal-notice">
              <strong>Аккредитация в Минцифры России:</strong> ООО «Девять Айти»
              внесено в реестр аккредитованных организаций, осуществляющих
              деятельность в области информационных технологий, 14.04.2025 за
              номером 67345. Компания оказывает услуги и выполняет работы по
              проектированию, разработке, адаптации, модификации, сопровождению,
              технической поддержке и эксплуатации программ для электронных
              вычислительных машин и баз данных (код вида деятельности 1.01 по
              приказу Минцифры от 11.05.2023 № 449).
            </div>

            <div className="legal-notice">
              <strong>Уведомление о смене наименования:</strong> до 18 мая 2026
              года организация имела наименование ООО «Ти-Ар Технолоджис». С 18
              мая 2026 года юридическое лицо переименовано в ООО «Девять Айти».
              ИНН, ОГРН и иные регистрационные данные остаются прежними.
            </div>

            <section className="legal-section">
              <h2 className="title-4 legal-section__title">
                1. Реквизиты и контакты
              </h2>
              <ul className="legal-list">
                <li>
                  <strong>Полное наименование:</strong> Общество с ограниченной
                  ответственностью «Девять Айти»
                </li>
                <li>
                  <strong>Сокращённое наименование:</strong> ООО «Девять Айти»
                </li>
                <li>
                  <strong>Прежнее наименование:</strong> ООО «Ти-Ар Технолоджис»
                  (до 18 мая 2026 года)
                </li>
                <li>
                  <strong>ИНН:</strong> 5040183840
                </li>
                <li>
                  <strong>Основной ОКВЭД:</strong> 62.01 — Разработка
                  компьютерного программного обеспечения
                </li>
                <li>
                  <strong>Адрес:</strong> Московская область, Раменский р-н,
                  кв-л 4/615, стр. 1, помещ. 6
                </li>
                <li>
                  <strong>Телефон:</strong>{" "}
                  <a href="tel:+74994440567">+7 (499) 444-05-67</a>
                </li>
                <li>
                  <strong>Электронная почта:</strong>{" "}
                  <a href="mailto:hello@its9it.ru">hello@its9it.ru</a>
                </li>
              </ul>
            </section>

            <section className="legal-section">
              <h2 className="title-4 legal-section__title">
                2. Коды видов деятельности по приказу Минцифры от 11.05.2023
                № 449
              </h2>
              <p>
                <strong>
                  1.01 — Разработка, сопровождение и техническая поддержка
                  программ для ЭВМ и баз данных
                </strong>
              </p>
              <p className="text-gray">
                Полная формулировка согласно утверждённому перечню в приказе
                Минцифры от 11.05.2023 № 449:
              </p>
              <p>
                Проектирование, и (или) обследование, и (или) разработка, и
                (или) адаптация, и (или) модификация (в том числе локализация,
                кастомизация, доработка), и (или) обратное проектирование
                (реверсивный инжиниринг), и (или) модернизация, и (или)
                обновление, и (или) установка, и (или) интеграция, и (или)
                настройка, и (или) конфигурирование, и (или) внедрение, и (или)
                сопровождение, и (или) тестирование, и (или) испытания, и (или)
                техническая поддержка, и (или) эксплуатация, включая
                администрирование, а также оказание услуг (в том числе
                консультационных, услуг по обучению, экспертных услуг и иных) в
                указанных видах деятельности, в отношении программ для ЭВМ, и
                (или) баз данных (в том числе их обновлений и исправлений), и
                (или) визуальных пользовательских интерфейсов.
              </p>
              <p>
                <strong>
                  2.01 — Реализация программ для ЭВМ и баз данных, в том числе
                  путём предоставления прав использования (лицензирования)
                </strong>
              </p>
              <p className="text-gray">
                Полная формулировка согласно утверждённому перечню в приказе
                Минцифры от 11.05.2023 № 449:
              </p>
              <p>
                Реализация программ для ЭВМ, баз данных (включая их обновления и
                изменения), средств защиты информации, в том числе путём
                отчуждения прав, предоставления прав (лицензирования),
                предоставления удалённого доступа посредством
                информационно-телекоммуникационных сетей, включая
                информационно-телекоммуникационную сеть «Интернет»,
                предоставление удалённых вычислительных мощностей, эмулирующих
                физическое оборудование, копирования, оптовой и розничной
                продажи экземпляров программ для ЭВМ, баз данных, издание
                сборников программ для ЭВМ и баз данных, предоставления
                экземпляров программ для ЭВМ, баз данных в лизинг, аренду
                (прокат).
              </p>
            </section>

            <section className="legal-section">
              <h2 className="title-4 legal-section__title">
                3. Реализуемые продукты, услуги и работы
              </h2>
              <h3 className="legal-section__subtitle">Продукты</h3>
              <ul className="legal-list">
                <li>
                  <strong>
                    «Умный регион: Платформа цифровизации туризма»
                  </strong>{" "}
                  — собственная программная платформа для цифровизации
                  туристической отрасли региона. Сайт продукта:{" "}
                  <a
                    href="https://smartregion.ru/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    smartregion.ru
                  </a>
                </li>
              </ul>
              <h3 className="legal-section__subtitle">Услуги и работы</h3>
              <ul className="legal-list">
                <li>
                  Проектирование и разработка программного обеспечения, в том
                  числе прототипов (MVP) и цифровых продуктов
                </li>
                <li>Разработка программного обеспечения на заказ</li>
                <li>
                  Адаптация, модификация и доработка программного обеспечения
                </li>
                <li>
                  Внедрение, настройка, сопровождение и техническая поддержка
                  программного обеспечения
                </li>
                <li>
                  Предоставление прав использования программы для ЭВМ «Умный
                  регион: Платформа цифровизации туризма» по лицензионному
                  договору (модели SaaS и on-premise)
                </li>
                <li>
                  Консультационные и экспертные услуги в области информационных
                  технологий
                </li>
              </ul>
            </section>

            <section className="legal-section">
              <h2 className="title-4 legal-section__title">
                4. Стоимость товаров, работ, услуг
              </h2>
              <p className="legal-note">Все цены указаны без учёта НДС.</p>
              <h3 className="legal-section__subtitle">
                Платформа «Умный регион: Платформа цифровизации туризма»
              </h3>
              <div className="legal-table-wrap">
                <table className="legal-table">
                  <thead>
                    <tr>
                      <th>Модель поставки лицензий</th>
                      <th>Стоимость</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Интернет-сервис (SaaS) — аренда выделенного виртуального
                        сервера
                      </td>
                      <td>от 4 500 000 ₽ / год</td>
                    </tr>
                    <tr>
                      <td>
                        Размещение в инфраструктуре заказчика (on-premise)
                      </td>
                      <td>от 10 000 000 ₽</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="legal-section__subtitle">
                Услуги по разработке, сопровождению и технической поддержке
              </h3>
              <div className="legal-table-wrap">
                <table className="legal-table">
                  <thead>
                    <tr>
                      <th>Роль / специалист</th>
                      <th>Стартовая ставка</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Frontend-разработчик</td>
                      <td>от 3 500 ₽ / час</td>
                    </tr>
                    <tr>
                      <td>Backend-разработчик</td>
                      <td>от 4 000 ₽ / час</td>
                    </tr>
                    <tr>
                      <td>Mobile-разработчик</td>
                      <td>от 4 000 ₽ / час</td>
                    </tr>
                    <tr>
                      <td>DevOps-инженер</td>
                      <td>от 4 500 ₽ / час</td>
                    </tr>
                    <tr>
                      <td>QA-инженер (тестировщик)</td>
                      <td>от 3 000 ₽ / час</td>
                    </tr>
                    <tr>
                      <td>UI/UX-дизайнер</td>
                      <td>от 3 500 ₽ / час</td>
                    </tr>
                    <tr>
                      <td>Системный аналитик</td>
                      <td>от 4 000 ₽ / час</td>
                    </tr>
                    <tr>
                      <td>Project-менеджер</td>
                      <td>от 4 000 ₽ / час</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                Итоговая стоимость работ, услуг и предоставления прав
                использования программного обеспечения определяется
                индивидуально на основании требований заказчика и фиксируется в
                договоре.
              </p>
              <p>
                Для получения коммерческого предложения обратитесь по контактам,
                указанным в разделе 1.
              </p>
            </section>

            <section className="legal-section">
              <h2 className="title-4 legal-section__title">
                5. Сведения об исключительных правах
              </h2>
              <p>
                ООО «Девять Айти» является обладателем исключительных прав на
                программу для ЭВМ{" "}
                <strong>
                  «Умный регион: Платформа цифровизации туризма»
                </strong>
                .
              </p>
              <p>
                <strong>Способы предоставления прав использования:</strong>
              </p>
              <ul className="legal-list">
                <li>
                  по лицензионному договору (простая неисключительная лицензия) в
                  модели SaaS — аренда выделенного виртуального сервера;
                </li>
                <li>
                  по лицензионному договору при размещении программы в
                  инфраструктуре заказчика (on-premise).
                </li>
              </ul>
              <p>
                Для заключения договора — обратиться по контактам, указанным в
                разделе 1.
              </p>
            </section>

            <section className="legal-section">
              <h2 className="title-4 legal-section__title">
                6. Технологический стек
              </h2>
              <h3 className="legal-section__subtitle">Frontend</h3>
              <p>Bootstrap, React, JavaScript, Next.js</p>
              <h3 className="legal-section__subtitle">Backend</h3>
              <p>
                Node.js, Python, FastAPI, Django, PHP, Bitrix, C#, .NET Core,
                ASP.NET, Entity Framework, PostgreSQL, MS SQL Server
              </p>
              <h3 className="legal-section__subtitle">Mobile</h3>
              <p>Flutter, Unity</p>
              <h3 className="legal-section__subtitle">DevOps</h3>
              <p>Docker, Kubernetes, GitLab</p>
              <h3 className="legal-section__subtitle">Data, AI &amp; BI</h3>
              <p>
                Python, Pandas, ClickHouse, Yandex DataLens, Visiology, Loginome,
                Qlik
              </p>
            </section>

            <section className="legal-section">
              <h2 className="title-4 legal-section__title">
                7. Сведения о включении ПО в реестр российского ПО
              </h2>
              <p>
                Программа для ЭВМ{" "}
                <strong>
                  «Умный регион: Платформа цифровизации туризма»
                </strong>{" "}
                включена в единый реестр российского программного обеспечения.
              </p>
              <ul className="legal-list">
                <li>
                  <strong>Номер реестровой записи:</strong> 27888
                </li>
                <li>
                  <strong>Дата включения в реестр:</strong> 06.05.2025
                </li>
                <li>
                  <strong>Карточка в реестре:</strong>{" "}
                  <a
                    href="https://reestr.digital.gov.ru/reestr/3323221/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    reestr.digital.gov.ru/reestr/3323221/
                  </a>
                </li>
                <li>
                  <strong>Сайт продукта:</strong>{" "}
                  <a
                    href="https://smartregion.ru/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    smartregion.ru
                  </a>
                </li>
              </ul>
              <p>
                <strong>
                  Класс ПО по классификатору (приказ Минцифры от 22.09.2020
                  № 486):
                </strong>
              </p>
              <ul className="legal-list">
                <li>
                  <strong>Основной:</strong> 12.13 — Программное обеспечение для
                  решения отраслевых задач в области гостиничного и
                  туристического бизнеса, предприятий общественного питания
                </li>
                <li>
                  <strong>Дополнительный:</strong> 12.20 — Информационные системы
                  для решения специфических отраслевых задач
                </li>
              </ul>
              <p>
                <strong>
                  Способы распространения и предоставления прав использования:
                </strong>
              </p>
              <ul className="legal-list">
                <li>
                  Интернет-сервис (SaaS): аренда выделенного виртуального сервера
                </li>
                <li>Размещение в инфраструктуре заказчика (on-premise)</li>
              </ul>
            </section>

          </div>
        </div>
      </main>
      </div>

      <div className="legal-footer-wrap">
        <Footer />
      </div>
      <ModalForm show={modalShow} onHide={setModalShow} />
    </div>
  );
}
